import ConfirmationModal, { ConfirmationModalProps } from './ConfirmationModal';

export type { ConfirmationModalProps };
export default ConfirmationModal;
